export const init = () => {
    /*
        this is the global snippet for our Google Analytics:

        <!-- Global site tag (gtag.js) - Google Analytics -->
        <script async src="https://www.googletagmanager.com/gtag/js?id=UA-52488016-6"></script>
        <script>
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'UA-52488016-6');
        </script>

     */

    // creating an empty `<script />` tag element
    const firstScriptTag = document.createElement('script');

    // adding async attribute to the element: Element.setAttribute(name, value)
    firstScriptTag.setAttribute('async', 'true');

    // setting the src attribute, note it won't start loading yet.
    firstScriptTag.src = 'https://www.googletagmanager.com/gtag/js?id=UA-52488016-6';

    // In order for it to become part of the page, you need to attach it
    // to the DOM, to keep things clean, we will append it to the page's
    // <head /> tag.
    document.head.appendChild(firstScriptTag);

    // repeat for the second script tag
    const secondScriptTag = document.createElement('script');
    secondScriptTag.text =
        "window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', 'UA-52488016-6');";
    document.head.appendChild(secondScriptTag);
}

export const sendGtagEvent = (eventName: string, payloadObj: any) => {
    window.gtag && window.gtag('event', eventName, payloadObj);
}

export default {
    init
};